// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.componentSearch .bootstrap-table .fixed-table-toolbar .bs-bars {\n  width: 80%;\n}\n", ""]);
// Exports
module.exports = exports;
